/* eslint-disable */
import { ApiKeyGetListForOperatorResponseItemDto, fixApiKeyGetListForOperatorResponseItemDtoFromJson, fixApiKeyGetListForOperatorResponseItemDtoToJson } from '../dto/api-key-get-list-for-operator-response-item-dto';

export interface ApiKeyGetListForOperatorResponseDto {
  items: ApiKeyGetListForOperatorResponseItemDto[];
  totalItems: number;
}

export const fixApiKeyGetListForOperatorResponseDtoFromJson = (dto?: ApiKeyGetListForOperatorResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.items?.forEach((x, i, a) => fixApiKeyGetListForOperatorResponseItemDtoFromJson(a[i]));
};

export const fixApiKeyGetListForOperatorResponseDtoToJson = (dto?: ApiKeyGetListForOperatorResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.items?.forEach((x, i, a) => fixApiKeyGetListForOperatorResponseItemDtoToJson(a[i]));
};
